module.exports = __webpack_public_path__ + "fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.703cf8f2.703cf8f2.woff2";